import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import { ShiftPaymentStrategy } from '@shared/modules/shift-payment-strategies/shift-payment-strategy';

@Component({
    selector: 'app-shift-payment-strategy-select',
    styleUrls: ['./shift-payment-strategy-select.component.scss'],
    templateUrl: '../../../form-fields/select/select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ShiftPaymentStrategySelectComponent), multi: true }],
})
export class ShiftPaymentStrategySelectComponent extends BaseSelectFormFieldComponent<ShiftPaymentStrategy> implements OnInit {

    constructor(element: ElementRef, renderer: Renderer2) {
        super(element, renderer);

        this._options = [
            {
                label: 'Bookings only',
                value: ShiftPaymentStrategy.bookingsOnly,
                description: 'The carer will only get paid for the bookings they attend',
            },
            {
                label: 'Shift only',
                value: ShiftPaymentStrategy.shiftOnly,
                description: 'The carer will only get paid for the length of the shift, irrespective of the amount/length of calls ' +
                    'within. Bookings outside of a shift will be paid separately',
            },
            {
                label: 'Shift and Bookings',
                value: ShiftPaymentStrategy.bookingsAndShift,
                description: 'The carer will get paid for the length of the shift, in addition to the individual bookings within it',
            },
        ];
    }

}
